import type { FaireProductEntity } from "../../entity_types/product";

export const p_jwr2a6nvkz: FaireProductEntity = {
  token: "p_jwr2a6nvkz",
  type: "product",
  name: "QUARTER ZIP HIGH NECK SHERPA FLEECE PULLOVER TOP",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl: "https://cdn.faire.com/fastly/530abda405cfeac68a7c9c8555b26903c272254452e0e1121b67b5748012ed4f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e54fc88f33e1ae572ca5cecfeba51bf899013ecf6b7316b3dcecaf721257c73a.jpeg",
    "https://cdn.faire.com/fastly/2be6ca50e6788a884ba90ce85e6dd3317c652ec5481f9584c503e29fb7eab004.jpeg",
    "https://cdn.faire.com/fastly/0f2b1b4579a2fc2aa736f335518afc34322c1a1d622c978f4f18f2034c128ffc.jpeg",
    "https://cdn.faire.com/fastly/34a58ff575929ed3f47307b02753010d68a59707f1776d577861cf280fbfdb42.jpeg",
    "https://cdn.faire.com/fastly/0f0b79dd9e5854c8a11d7c073399c042a55609285f224076bce578a7825cd4fe.jpeg",
    "https://cdn.faire.com/fastly/841f1339f69fbf59526b00488f427c9e93f191d62732a992c0155d1b158a97bf.jpeg",
    "https://cdn.faire.com/fastly/5d729ce698cdc4c30ec1fce5bb39265f7445c042012e1d8693ec175497675418.jpeg",
    "https://cdn.faire.com/fastly/07d368cb62e50892079659fffcb37207a27e550d5b9efa02d65dd5c5666a0806.jpeg",
    "https://cdn.faire.com/fastly/ec70afbcef2af078425955166db323d0ac839687bd05592894b13912bbf6eff3.jpeg",
    "https://cdn.faire.com/fastly/d68dcf3f838e60e9ab054fe4c54e1e5441dc6667aedf27b745dcc1f8a2ac25a9.jpeg",
    "https://cdn.faire.com/fastly/4e36bb3a85f5f3d73f615e9093f298d26f948a064c847e1fe514c6f9b58ea156.jpeg",
    "https://cdn.faire.com/fastly/708c5a8a0ecc36826491f50ce8acf2b946e532527a233bb9a2170d8cb53e5da4.jpeg",
    "https://cdn.faire.com/fastly/8713b3c90d22e6bf5d1176638d6ef17036cc399b315cdd749fa97e36b347ba3a.jpeg",
    "https://cdn.faire.com/fastly/8fc020a930455ec0755f857c2a13f32705cb312546b2c5db0be5173caeadd1d1.jpeg",
    "https://cdn.faire.com/fastly/628d37854b632c5e8161be0475f9691528165908111c7e6245b2e414e68c3995.jpeg",
    "https://cdn.faire.com/fastly/941b2dcb857ada9dbf18365e02ea0e0cba79d9749d819b9e91710e379a3619fe.jpeg",
    "https://cdn.faire.com/fastly/51bb39e3f25b9d643788647fc718b57ad7b00e7bf61c1c840235b9f8d358a07d.jpeg",
    "https://cdn.faire.com/fastly/c6c8c43d5075c01bcc44aff1c1aaad6871a14e05f8406efe96a8510eb0ba5c8e.jpeg"
  ],
  priceDollars: 147,
  description: "Master the art of cozy dressing with this must-have sherpa pullover. Crafted from a plush, high-pile faux shearling in a rich forest green, this piece offers ultimate warmth and a soft-to-the-touch feel. It features a sophisticated high stand-up collar and a functional quarter-length front zipper for easy layering. The relaxed, boxy silhouette is accented by architectural seam detailing at the cuffs, providing a polished finish to this rugged staple. Whether you're heading for a trail walk or a coffee run, this pullover is your new cold-weather hero.\n\n-Fabric: Ultra-soft, mid-weight faux shearling (Sherpa fleece).\n-Neckline: High stand-up collar with a quarter-zip front.\n-Fit: Relaxed, slightly boxy silhouette.\n-Sleeves: Long sleeves with decorative panel seaming at the cuffs.\n-Finish: Straight, clean-cut hemline.\n-Model is 5'9\" and wearing a Small",
  tags: [],
  msrpDollars: 294,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:32.218Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
